<template>
    <div>
      {{unidades}}
      <LineChartGenerator
      :chart-options="chartOptionsMutado"
      :chart-data="chartData"
    />
    </div>
   
  </template>
  
  <script>
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
  import zoomPlugin from 'chartjs-plugin-zoom';
  import annotationPlugin from 'chartjs-plugin-annotation';
  import 'chartjs-adapter-moment'
  import {mapState} from 'vuex'
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
  
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
    TimeScale
  } from 'chart.js'
  
  ChartJS.register(  Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    zoomPlugin,
    annotationPlugin,
    TimeScale,
    CategoryScale)
  
  export default {
    name: 'LineChart',
    components: {
      LineChartGenerator
    },
    props: {
      unidades:String,
      chartData: {
        labels:Array,
        datasets: Array,
      },
      plugins: {
        type: Array,
        default: () => []
      },
      tromel:Boolean,
      temp1_configuracion:String,
      temp2_configuracion:String,
    },
    methods: {
      kk(v){
        return `kk ${v}`
      }
    },
    computed: {
      ...mapState([
          'higienizacion1',
          'higienizacion2',
      ]),
      chartOptionsMutado(){
        let thenAnotations = {}
        if(typeof(this.temp1_configuracion) == 'undefined'){
          thenAnotations=(this.tromel)? {
            annotations: {
                line1: {
                  type: 'line',
                  yMin: parseFloat(this.higienizacion1.temperaturaUmbral),
                  yMax: parseFloat(this.higienizacion1.temperaturaUmbral),
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
                },
                line2: {
                  type: 'line',
                  yMin: parseFloat(this.higienizacion2.temperaturaUmbral),
                  yMax: parseFloat(this.higienizacion2.temperaturaUmbral),
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
                }
              }
            }:{}
        }else{
  
          thenAnotations=(this.tromel)? {
            annotations: {
                line1: {
                  type: 'line',
                  yMin: parseFloat(this.temp1_configuracion),
                  yMax: parseFloat(this.temp1_configuracion),
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
                },
                line2: {
                  type: 'line',
                  yMin: parseFloat(this.temp2_configuracion),
                  yMax: parseFloat(this.temp2_configuracion),
                  borderColor: 'rgb(255, 99, 132)',
                  borderWidth: 2,
                }
              }
            }:{}
        }
        
        let k={
          plugins: {
            title: {
              display: true,
              // text: this.title,
              font: {
                size: 18
              }
            },
            annotation: thenAnotations,
            zoom: {
              zoom: {
                wheel: {
                  enabled: true,
                },
                pinch: {
                  enabled: true
                },
                mode: 'x',
                pan: {
                  enabled: true
                },
                drag: {
                  enabled: true
                }
              }
            }
          },
           animation: {
              duration: 0
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              type: 'time',
              time: {
                displayFormats: {
                  quarter: 'MMM YYYY'
                  // quarter: 'HH:mm:ss'
                }
              }
            },
            y: {
                ticks: {
                  stepSize: 1,
                    callback: function(value, index) {
                      
                        return value
                    }
                },
                //suggestedMin: 0,
                suggestedMax: 100
            },
          }
        } 
        return k
      }
    },
  
    data() {
  
      return {
       
        chartOptions: {
          animation: {
              duration: 0
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
              y: {
                  ticks: {
                    stepSize: 20,
                      callback: function(value, index) {
                          return `${value} ºC`;
                      }
                  },
                  suggestedMin: 0,
                  suggestedMax: 100
              }
          }
        }
      }
    },
  }
  </script>